export default "__VITE_ASSET__B9Mch1WH__"